import { connect } from 'react-redux'
import visitorsSelector from './visitorsSelector'
import Visitors from './Visitors'
import { withCardContext } from 'dataProviders/Card'

export default withCardContext(connect(
  visitorsSelector,
  {}
)(Visitors))
